import { Injectable } from '@angular/core';
import { uniqBy } from 'lodash';
import { Dashboard, TriggerEvent, TriggerEventType } from '../../../models';
export type EventMap = {
    nodes: any[];
    edges: any[];
};

@Injectable({
    providedIn: 'root',
})
export class IqBuilderAuditToolDashboardEventsService {
    constructor() {}

    createEventMap(dashboard: TriggerEventType): EventMap {
        const nodes: any[] = Object.keys(dashboard)
            .filter((key) => key.startsWith('on'))
            .map((key) => {
                const tiggerEvents: TriggerEvent[] = dashboard[key];
                const nodes: any[] = tiggerEvents.map((triggerEvent) => {
                    return {
                        id: triggerEvent.name,
                        label: triggerEvent.name,
                    };
                });

                return [
                    {
                        id: key,
                        label: key,
                    },
                    ...nodes,
                ];
            })
            .flat();
        const uniqueNodes = uniqBy(nodes, 'id');
        const edges = Object.keys(dashboard)
            .filter((key) => key.startsWith('on'))
            .map((key) => {
                const triggerEvents: TriggerEvent[] = dashboard[key];
                const edges = triggerEvents.map((triggerEvent) => {
                    return {
                        source: key,
                        target: triggerEvent.name,
                    };
                });

                return edges;
            })
            .flat();

        return {
            nodes: uniqueNodes,
            edges: edges,
        };
    }
}
